import React, { Component } from 'react'
import { Modal, Button, Col, Row, Container } from "react-bootstrap-v5";
import FileViewer from 'react-file-viewer';

class FileReader extends Component {
    constructor(props){
        super(props)

        this.state = {
            showModal: false,
            filetype: '',
            file:''
        }
    }

    componentDidMount() {

        const query = new URLSearchParams(this.props.location.search);

        this.setState({filetype: query.get('type'), file: query.get('file')})

    }

    onError(e) {
        console.log("e--", e);
    }

    handleShow = (value) => this.setState({ showModal: value })

    render(){
        const { filetype, file } = this.state

        if(filetype === '' || file === '') return false

        return <>
                    <FileViewer
                        fileType={filetype}
                        filePath={file}
                        onError={this.onError}
                    />
                {/* <Button key="fileRead" size="sm" variant="primary" onClick={() => this.handleShow(true)}>
                    View File
                </Button>

                <Modal key={file} show={this.state.showModal} onHide={() => this.handleShow(false)} dialogClassName="modal-90w">
                    <Modal.Header closeButton>
                        <Modal.Title>File</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <FileViewer
                            fileType={fileType}
                            filePath={file}
                            onError={this.onError}
                        />
                    </Modal.Body>

                </Modal> */}
        </>
    }
}

export { FileReader }
